import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="mb-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs text-[#4a4d52]">
        {items.map((it, i) => (
          <li key={it.path} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight size={13} className="text-[#c3c8d0]" />}
            {i === items.length - 1 ? (
              <span className="font-medium text-[#16181D]">{it.name}</span>
            ) : (
              <Link to={it.path} className="transition-colors hover:text-[#E2611C]">{it.name}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
